/*
 * @Author: LiuMeiYu
 * @Date: 2022-10-24 11:57:27
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-02 10:33:16
 * @FilePath: \cardtey\src\main.ts
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "element-plus/dist/index.css";

createApp(App).use(store).use(router).mount("#app");
